import { Box, Grid, Paper, Typography, useTheme } from "@mui/material";
import { Enumerations } from "../../config/Enumerations";
import moment from "moment";

export default function EntryDetails({ appEntry }) {
  const theme = useTheme();

  return (
    <Grid item xs={12} md={6}>
      <Paper elevation={3} sx={{ padding: 2 }}>
        <div className="entry-details-title">
          <Typography
            variant="h6"
            style={{ color: theme.palette.secondary.main }}
          >
            Детали за барањето
          </Typography>
        </div>
        <Box className="entry-details-row margin-top">
          <div className="entry-details-block">
            <Typography variant="caption" display="block">
              Тип на барање
            </Typography>
            <Typography className="inter-medium">
              {Enumerations.AppEntryTypeDisplay[appEntry?.type]}
            </Typography>
          </div>
          <div>
            <Typography variant="caption">Датум на поднесување</Typography>
            <Typography className="inter-medium">
              {moment(appEntry?.dateSubmitted).format("DD.MM.YYYY HH:mm")}
            </Typography>
          </div>
        </Box>
        <Box className="entry-details-row">
          <div className="entry-details-block">
            <Typography variant="caption" display="block">
              Подносител
            </Typography>
            <Typography variant="body1" className="inter-medium">
              {appEntry?.appEntryData?.applicantName}
            </Typography>
            <Typography variant="body1" className="inter-medium">
              {appEntry?.appEntryData?.applicantEmail}
            </Typography>
            <Typography variant="body1" className="inter-medium">
              {appEntry?.appEntryData?.applicantPhone}
            </Typography>
          </div>
        </Box>
        <Box className="entry-details-row">
          <div className="entry-details-flex-row">
            <div>
              <Typography variant="caption" display="block">
                Адреса
              </Typography>
              <Typography className="address-text inter-medium">
                {appEntry?.appEntryData?.applicantAddress}
              </Typography>
              <Typography className="address-text inter-medium">
                {appEntry?.appEntryData?.applicantPlace}
              </Typography>
            </div>
          </div>
        </Box>
      </Paper>
    </Grid>
  );
}
